import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const ConnectContext = createContext({ open: false, openConnect: () => {}, closeConnect: () => {} });

export const ConnectProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openConnect = useCallback(() => setOpen(true), []);
  const closeConnect = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ open, setOpen, openConnect, closeConnect }), [open, openConnect, closeConnect]);
  return <ConnectContext.Provider value={value}>{children}</ConnectContext.Provider>;
};

export const useConnect = () => useContext(ConnectContext);
